import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-ekey-login',
  templateUrl: './ekey-login.component.html',
  styleUrls: ['./ekey-login.component.scss']
})
export class EkeyLoginComponent implements OnInit {

  cprValue: string = '';

  constructor(private router: Router) { }

  ngOnInit() {
  }

  login() {
    let navigationExtras: NavigationExtras = {
      queryParams: { 'ticket': '11224466', 'classSessionId': 'g1dsl2sal183m328jkz', 'cpr': this.cprValue},
    };
    // redirect to  to the login page with extras
    this.router.navigate(['/login'], navigationExtras);
  }

}
